import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  ArrowLeftIcon, 
  DevicePhoneMobileIcon, 
  QrCodeIcon, 
  ArrowDownTrayIcon, 
  CheckCircleIcon,
  ShieldCheckIcon,
  BoltIcon
} from '@heroicons/react/24/outline';

export default function DownloadApp() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-white font-sans flex flex-col justify-between relative overflow-hidden pb-24 md:pb-12">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-96 bg-gradient-to-b from-blue-600/20 via-indigo-600/10 to-transparent pointer-events-none -z-10 blur-3xl" />

      {/* Top Header */}
      <header className="relative z-50 flex items-center justify-between px-5 pt-safe-top pt-4 max-w-3xl mx-auto w-full">
        <button
          onClick={() => navigate('/')}
          className="w-10 h-10 flex items-center justify-center rounded-2xl bg-white/10 backdrop-blur-md border border-white/10 text-white transition-all active:scale-90"
          aria-label="Back to Home"
        >
          <ArrowLeftIcon className="w-5 h-5" />
        </button>

        {/* Brand Pill */}
        <div className="flex items-center gap-2.5 bg-white/10 backdrop-blur-md border border-white/10 rounded-full px-4 py-2 shadow-lg">
          <img src="/logo-icon.svg" alt="Prindox" className="w-5 h-5 object-contain" />
          <span className="text-white text-xs font-black tracking-wider uppercase">Prindox Mobile</span>
        </div>

        <div className="w-10" />
      </header>

      {/* Main Content */}
      <main className="flex-1 max-w-xl mx-auto w-full px-5 py-8 flex flex-col items-center text-center justify-center">
        {/* App Icon */}
        <div className="w-24 h-24 bg-white rounded-3xl p-3 shadow-2xl shadow-blue-500/20 border border-white/20 mb-6 flex items-center justify-center">
          <img src="/logo-icon.svg" alt="Prindox Logo" className="w-16 h-16 object-contain" />
        </div>

        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-xs font-bold mb-4">
          <BoltIcon className="w-4 h-4" />
          <span>Fast, Lightweight & Native</span>
        </div>

        <h1 className="text-3xl sm:text-4xl font-black tracking-tight text-white mb-3">
          Get the Prindox App
        </h1>
        <p className="text-slate-400 text-sm max-w-md mx-auto mb-8 leading-relaxed">
          Scan QR codes at any print shop, upload your files securely in seconds, and track your print job status in real time.
        </p>

        {/* Features List */}
        <div className="w-full bg-white/5 border border-white/10 rounded-3xl p-5 mb-8 backdrop-blur-md text-left space-y-3">
          <div className="flex items-center gap-3">
            <CheckCircleIcon className="w-5 h-5 text-emerald-400 shrink-0" />
            <span className="text-xs font-semibold text-slate-200">Zero signup needed for senders</span>
          </div>
          <div className="flex items-center gap-3">
            <CheckCircleIcon className="w-5 h-5 text-emerald-400 shrink-0" />
            <span className="text-xs font-semibold text-slate-200">End-to-end privacy with automatic deletion</span>
          </div>
          <div className="flex items-center gap-3">
            <CheckCircleIcon className="w-5 h-5 text-emerald-400 shrink-0" />
            <span className="text-xs font-semibold text-slate-200">Instant shopkeeper notifications & receipts</span>
          </div>
        </div>

        {/* Download & Action Buttons */}
        <div className="w-full space-y-3.5">
          <Link
            to="/send"
            className="w-full py-4 px-6 bg-blue-600 hover:bg-blue-500 text-white rounded-2xl font-black uppercase tracking-wider text-xs shadow-xl shadow-blue-600/30 flex items-center justify-center gap-3 transition-all active:scale-95"
          >
            <QrCodeIcon className="w-5 h-5" />
            <span>Launch Web Scanner (No Install)</span>
          </Link>

          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              alert("Android APK is packaged with Capacitor. To run native APK, open frontend/android in Android Studio or build APK!");
            }}
            className="w-full py-4 px-6 bg-white/10 hover:bg-white/15 text-white border border-white/15 rounded-2xl font-black uppercase tracking-wider text-xs flex items-center justify-center gap-3 transition-all active:scale-95"
          >
            <ArrowDownTrayIcon className="w-5 h-5 text-blue-400" />
            <span>Download Android App (.apk)</span>
          </a>
        </div>

        {/* Security badge */}
        <div className="mt-8 flex items-center gap-2 text-slate-500 text-xs">
          <ShieldCheckIcon className="w-4 h-4 text-emerald-500" />
          <span>Verified Safe & 100% Virus-Free</span>
        </div>
      </main>
    </div>
  );
}
